import { format } from "date-fns";
import { AlertTriangle, MoveRight } from "lucide-react";
import { Link } from "react-router-dom";

import { Card } from "@/components/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { ConcurrencyResponseItem } from "@classview/shared-types";

import { VIDYO_CONCURRENCY_LIMIT } from "./concurrency";

type ConcurrencyOverageProps = {
  days: ConcurrencyResponseItem[];
};

export function ConcurrencyOverage({ days }: ConcurrencyOverageProps) {
  if (days.length === 0) {
    return null;
  }

  return (
    <>
      <p className="px-4 py-2 text-sm font-semibold text-foreground">
        Potential Concurrency Overage's
      </p>
      <Card.Content>
        {days.map((concurrency) => {
          return (
            <Alert className="mt-4 border-border p-2" key={concurrency.day}>
              <div className="border-l-2 border-warning p-2">
                <AlertTitle className="flex items-center text-sm text-warning">
                  <AlertTriangle className="mr-2 h-4 w-4" />
                  Expected Overage:{" "}
                  {concurrency.count - VIDYO_CONCURRENCY_LIMIT}
                </AlertTitle>
                <AlertDescription>
                  <p className="mt-4 text-sm leading-none">
                    {format(new Date(concurrency.day), "MMM dd, yyyy")}
                  </p>

                  <Button variant="outline" className="ml-auto mt-4" asChild>
                    <Link to={`/admin/sessions?day=${concurrency.day}`}>
                      View Sessions <MoveRight className="ml-2 size-4" />
                    </Link>
                  </Button>
                </AlertDescription>
              </div>
            </Alert>
          );
        })}
      </Card.Content>
    </>
  );
}
